<template>
  <ion-item lines="inset" :disabled="disabled" @click="openEditor()" class="ion-activatable ripple-parent">
    <ion-label position="stacked">Constatering</ion-label>
    <span style="text-overflow: ellipsis;white-space: break-spaces" class="my-2 mr-8" v-html="current_selected"></span>
    <ion-icon size="small" color="primary" class="edit-icon" :icon="createOutline"></ion-icon>
    <ion-ripple-effect></ion-ripple-effect>
  </ion-item>

  <!-- Description textarea -->
  <ion-item :disabled="disabled">
    <ion-label position="stacked">Toelichting</ion-label>
    <ion-textarea v-model="description" rows="5" placeholder="Optionele toelichting"></ion-textarea>
    <ion-ripple-effect></ion-ripple-effect>
  </ion-item>
</template>

<script>
import TextareaEditor from './RemarkEditor.vue'; // Updated import name to match refactored component
import { modalController } from '@ionic/vue';
import { createOutline } from 'ionicons/icons';

export default {
  name: 'novacheck-row',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Constatering'
    },
    field_name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    description_value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      createOutline,
      current_selected: '-',
      description: '',
      timer: null
    }
  },
  created() {
    // Initialize with props
    this.description = this.description_value || '';
    this.current_selected = this.value || '-';
  },
  methods: {
    /**
     * Debounce description updates to prevent excessive event emissions
     */
    debouncedUpdateDescription(newValue) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.$emit('updateDescription', newValue);
      }, 1000);
    },
    
    /**
     * Open the editor modal
     */
    async openEditor() {
      if (this.disabled) return;
      
      try {
        const modal = await modalController.create({
          component: TextareaEditor, // Updated component name
          componentProps: {
            value: this.current_selected !== '-' ? this.current_selected : '',
            label: this.label,
            placeholder: this.placeholder,
            description: this.description
          },
          initialBreakpoint: 1,
          breakpoints: [0, 1]
        });
        
        modal.present();

        const { data, role } = await modal.onWillDismiss();

        if (role === 'confirm' && data) {
          // Update local values
          this.current_selected = data.value || '-';
          this.description = data.description || '';
          
          // Emit events
          this.$emit('savePrivateRemark', !!data.save_private_remark);
          this.$emit('updateDescription', this.description);
          this.$emit('autoClassify', data.auto_classify);
        }
      } catch (error) {
        console.error('Failed to open editor:', error);
      }
    }
  },
  watch: {
    /**
     * Watch for changes to description_value prop
     */
    description_value: {
      handler(newValue) {
        if (newValue !== this.description) {
          this.description = newValue || '';
        }
      },
      immediate: true
    },
    
    /**
     * Watch for changes to local description and debounce updates
     */
    description(newValue) {
      this.debouncedUpdateDescription(newValue);
    },
    
    /**
     * Watch for changes to value prop
     */
    value: {
      handler(newValue) {
        if (newValue !== this.current_selected) {
          this.current_selected = newValue || '-';
        }
      },
      immediate: true
    },
    
    /**
     * Watch for changes to local current_selected and emit events
     */
    current_selected(newValue) {
      if (newValue !== '-') {
        this.$emit('change', newValue);
        this.$emit('update:value', newValue);
      }
    }
  },
  beforeUnmount() {
    // Clear any pending timers
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>

<style>
.edit-icon {
  position: absolute;
  right: 15px;
  margin-top: 20px;
}
</style>